module.exports = __webpack_public_path__ + "static/media/S1N11-2.8e27fbc5.svg";